import {
	IPermissionDict,
	IPermissionOperation,
	UserPermissionClass,
	UserPermissionSerialize,
} from "../bridge/define.permission";
import {UserCenter} from "../includes/user-center";
import {IPermDataArg, permDataObject} from "./user-permission";
import {IUserProfileBase} from "../bridge/define";

export class UserPermissionDict<IProfile extends IUserProfileBase> implements IPermissionDict, IPermissionOperation {
	protected readonly dic: Map<string, boolean>;
	protected readonly _id: string;
	
	constructor(userId: string, private uc: UserCenter<IProfile>) {
		this._id = userId;
		this.dic = new Map;
	}
	
	/** @private */
	_has(name: string) {
		return this.dic.has(name);
	}
	
	/** @private */
	_set(name: string, value: boolean) {
		return this.dic.set(name, value);
	}
	
	has(name: string) {
		return this.dic.get(name);
	}
	
	async grant(perm: IPermDataArg): Promise<void> {
		return this.uc.permission.grant(this._id, perm);
	}
	
	async check(perm: IPermDataArg, saveAs?: string): Promise<boolean> {
		let permData = permDataObject(perm);
		if (!saveAs) {
			saveAs = permData.permName;
		}
		if (this._has(saveAs)) {
			return Promise.resolve(this.dic.get(saveAs));
		}
		const ret = await this.uc.permission.check(this._id, permData);
		
		this.dic.set(saveAs, ret);
		
		return ret;
	}
	
	async drop(permData: UserPermissionSerialize|UserPermissionClass): Promise<void> {
		return this.uc.permission.drop(this._id, permData);
	}
	
	async dropLike(permData: UserPermissionSerialize|UserPermissionClass): Promise<void> {
		return this.uc.permission.dropLike(this._id, permData);
	}
}
